// extracted by mini-css-extract-plugin
export default {"rating":"YG-z","numberOfStars":"ZG-z","count":"_G-z","barGraphSpacing":"aH-z","barGraph":"bH-z"};